import { NavLink } from 'react-router-dom';

import { navigation } from '../content/site';

export function SiteHeader() {
  return (
    <header className="site-masthead">
      <div className="site-container site-masthead__inner">
        <NavLink className="site-name" to="/">Eli Schatz</NavLink>
        <nav aria-label="Primary navigation" className="site-nav">
          {navigation.map((item) => (
            <NavLink
              className={({ isActive }) =>
                `site-nav__link${isActive ? ' site-nav__link--active' : ''}`
              }
              key={item.to}
              to={item.to}
            >
              {item.label}
            </NavLink>
          ))}
          <a className="resume-link" href="/EliSchatzResume.pdf" target="_blank" rel="noreferrer">
            Résumé
          </a>
        </nav>
      </div>
    </header>
  );
}
